import { Link } from "react-router-dom";
import { categories } from "@/mocks/guaData";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-background-50">
      <div className="grid w-full grid-cols-1 gap-10 px-4 py-12 md:grid-cols-2 md:px-8 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg leading-none" aria-hidden="true" />
            </span>
            <span className="heading-font text-lg font-black">瓜田热榜</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-50/70">
            实时汇总今日热门吃瓜榜、最近吃瓜热点盘点与全网热议事件合集，帮你用三分钟跟上今天在聊什么。
          </p>
          <p className="mt-4 flex items-center gap-2 text-sm text-background-50/70">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-line text-base leading-none" aria-hidden="true" />
            </span>
            hello@guatianrebang.example.com
          </p>
        </div>

        <nav aria-label="热门分类">
          <h3 className="text-sm font-semibold tracking-wide text-accent-300">热门分类</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {categories.map((category) => (
              <li key={category.slug}>
                <Link
                  to={`/category/${category.slug}`}
                  className="cursor-pointer text-sm text-background-50/75 transition-colors hover:text-accent-200"
                >
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="站内导航">
          <h3 className="text-sm font-semibold tracking-wide text-accent-300">站内导航</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            <li>
              <Link to="/" className="cursor-pointer text-sm text-background-50/75 transition-colors hover:text-accent-200">
                首页盘点
              </Link>
            </li>
            <li>
              <Link to="/rank" className="cursor-pointer text-sm text-background-50/75 transition-colors hover:text-accent-200">
                今日热门吃瓜榜
              </Link>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer text-sm text-background-50/75 transition-colors hover:text-accent-200">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/about#principles" className="cursor-pointer text-sm text-background-50/75 transition-colors hover:text-accent-200">
                内容原则
              </Link>
            </li>
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-semibold tracking-wide text-accent-300">内容说明</h3>
          <p className="mt-4 text-sm leading-relaxed text-background-50/70">
            站内话题均由编辑根据公开讨论整理成脉络综述，只做事实归纳与观点呈现，不转载原始图文。涉及尚未证实的传闻会在文中明确标注。
          </p>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="flex w-full flex-col gap-2 px-4 py-5 text-xs text-background-50/60 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2026 瓜田热榜 · 内容仅供讨论参考</p>
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span>全网热议话题聚合平台</span>
            <span className="hidden h-3 w-px bg-background-50/20 md:block" />
            <span>如发现内容有误，欢迎邮件反馈更正</span>
          </p>
        </div>
      </div>
    </footer>
  );
}